import { render, staticRenderFns } from "./AppLayoutInstrutor.vue?vue&type=template&id=508dc57a&scoped=true"
import script from "./AppLayoutInstrutor.vue?vue&type=script&lang=js"
export * from "./AppLayoutInstrutor.vue?vue&type=script&lang=js"
import style0 from "./AppLayoutInstrutor.vue?vue&type=style&index=0&id=508dc57a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508dc57a",
  null
  
)

export default component.exports